module.exports = __webpack_public_path__ + "static/media/cu05_ch01.1db50536.png";